<template>
  <div :class="`${isGood ? 'tw-bg-green-200 tw-text-green-800' : 'tw-bg-red-200 tw-text-red-800'} tw-rounded-br tw-rounded-bl tw-p-1 tw-px-2 tw-w-full tw-text-xs`" v-if="percentage">
    <div class="tw-flex tw-items-center tw-justify-center">
      <svg v-if="percentage >= 0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" :class="`${isGood ? 'tw-text-green-800' : 'tw-text-red-800'} tw-inline tw-w-4 tw-h-4`">
        <path d="M4.5 12.75l7.5-7.5 7.5 7.5m-15 6l7.5-7.5 7.5 7.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2.5" stroke="currentColor" :class="`${isGood ? 'tw-text-green-800' : 'tw-text-red-800'} tw-w-4 tw-h-4 tw-inline`">
        <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 5.25l-7.5 7.5-7.5-7.5m15 6l-7.5 7.5-7.5-7.5" />
      </svg>
      <strong class="tw-mx-2">{{String(percentage).replace(".", ",")}}%</strong> {{text}}
    </div>
  </div>
  <div v-else class="tw-invisible">-</div>
</template>
<script>
export default {
  props: {
    percentage: Number,
    periodType: String,
    biggerIsBetter: {
      type: Boolean,
      // Unlike object or array default, this is not a factory function - this is a function to serve as a default value
      default() {
        return true
      }
    }
  },
  computed: {
    isGood(){
      return this.biggerIsBetter ? this.percentage >= 0.0 : this.percentage <= 0.0
    },
    text() {
      if (this.biggerIsBetter) {
        return `${this.percentage >= 0.0 ? "maior" : "menor"} que o ${this.periodType == "monthly" ? "mês" : "ano"} anterior`
      }
      return `${this.percentage >= 0.0 ? "maior" : "menor"} que o ${this.periodType == "monthly" ? "mês" : "ano"} ${this.percentage >= 0.0 ? "atual" : "anterior"}`
    }
  }
};
</script>
